// src/stores/UsersStore.js
// UsersStore — read-only, tenant-admin-facing state for /admin/entitlements/users.
// One focused store (mirrors SkuCatalogStore.js's scope — not folded into the
// growing EntitlementsStore). Fetch/unwrap mechanics mirror
// EntitlementsStore.load()'s {status, content} envelope handling.
import { makeAutoObservable, runInAction } from "mobx";

import { fetchTenantUsers } from "../queries/users";

class UsersStore {
  users = [];
  loading = false;
  error = null;
  lastFetchedAt = null;

  constructor(rootStore) {
    this.root = rootStore;
    makeAutoObservable(this, { root: false });
  }

  get authData() {
    return this.root?.userStore?.authData;
  }

  async load() {
    if (!this.authData) return;
    this.loading = true;
    this.error = null;
    try {
      const resp = await fetchTenantUsers(this.authData);
      const items = resp?.content?.users ?? resp?.users ?? [];
      runInAction(() => {
        this.users = items;
        this.lastFetchedAt = new Date();
        this.loading = false;
      });
    } catch (err) {
      console.error("UsersStore.load failed", err);
      runInAction(() => {
        this.error = err.message || String(err);
        this.loading = false;
      });
    }
  }
}

export default UsersStore;
